var map = {
	"./cracks.jpg": 358,
	"./crinkle-2.jpg": 677,
	"./crinkle.jpg": 629,
	"./grunge-2.jpg": 396,
	"./grunge.jpg": 719,
	"./leather.jpg": 825,
	"./stain.jpg": 743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;